// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"79afdb21","763":"7189c3e6"}[chunkId] + ".chunk.css";
};